import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=ed373dae&scoped=true&"
import script from "./SelectOption.vue?vue&type=script&lang=js&"
export * from "./SelectOption.vue?vue&type=script&lang=js&"
import style0 from "./SelectOption.vue?vue&type=style&index=0&id=ed373dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed373dae",
  null
  
)

export default component.exports